import { getNodeImage, getNodeName } from "Areas/SharedFeatures/nodeLabel";
import isDocumentMapDataPoint from "Areas/SharedFeatures/types/utils/isDocumentMapDataPoint";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import { MAP_GEOMETRY_TYPE, mapGeometryTypeIconMap, mapGeometryTypeLocale } from "Common/dictionaries/mapGeometryType";
import compact from "lodash/compact";
import map from "lodash/map";
import { SidebarMenuItem } from "../../Common";
export const buildNavigationObjectKey = (objId) => `documentNavigation_${objId}`;
export default (documentType, documentObjects, nodesSource, tableRow, mapObject) => {
    if (documentType === DOCUMENT_TYPE.GRAPH) {
        return compact(map(nodesSource, node => {
            const documentObject = documentObjects[node.DocumentObjectId];
            return (documentObject &&
                new SidebarMenuItem(buildNavigationObjectKey(node.NodeId), node.NodeName ||
                    getNodeName(node.AttributeValues, documentObject) ||
                    (documentObject === null || documentObject === void 0 ? void 0 : documentObject.Name), node.NodeImage || getNodeImage(node.AttributeValues, documentObject, true), undefined, node));
        }));
    }
    if (documentType === DOCUMENT_TYPE.TABLE) {
        return compact(map(tableRow, row => new SidebarMenuItem(buildNavigationObjectKey(row.id), row.text, row.imgSrc, undefined, row)));
    }
    if (documentType === DOCUMENT_TYPE.MAP) {
        return compact(map(mapObject, o => {
            var _a;
            if (isDocumentMapDataPoint(o)) {
                const mapDataPoint = o;
                const documentObject = mapDataPoint.NodeSource
                    ? documentObjects[mapDataPoint.NodeSource.DocumentObjectId]
                    : undefined;
                return (mapDataPoint.NodeId &&
                    new SidebarMenuItem(buildNavigationObjectKey(mapDataPoint.NodeId), mapDataPoint.Name ||
                        getNodeName((_a = mapDataPoint.NodeSource) === null || _a === void 0 ? void 0 : _a.AttributeValues, documentObject) ||
                        (documentObject === null || documentObject === void 0 ? void 0 : documentObject.Name), mapGeometryTypeIconMap[MAP_GEOMETRY_TYPE.POINT], undefined, mapDataPoint));
            }
            const mapDataGeometry = o;
            return (mapDataGeometry.Id &&
                new SidebarMenuItem(buildNavigationObjectKey(mapDataGeometry.Id), mapDataGeometry.Name || mapGeometryTypeLocale[mapDataGeometry.MapGeometryType], mapGeometryTypeIconMap[mapDataGeometry.MapGeometryType], undefined, mapDataGeometry));
        }));
    }
    return [];
};
